import dayjs from "dayjs";
import { taskLevelKeyValue, taskStatusKeyValue, taskLevelKeyOtherValue, messageLogActoinMap } from "@/utils/const.js";
import { mapGetters, mapState, mapMutations } from 'vuex';
import Vue from 'vue'
import { getTaskModel } from '@/utils/utils'
import { keyIcon } from '@/utils'
const mixin = {
  data() {
    return {
      createUniqueId(n) {
        var random = function () {
          // 生成10-12位不等的字符串
          return Number(Math.random().toString().substr(2)).toString(36) // 转换成十六进制
        }
        var arr = []
        function createId() {
          var num = random()
          var _bool = false
          arr.forEach((v) => {
            if (v === num) _bool = true
          })
          if (_bool) {
            createId()
          } else {
            arr.push(num)
          }
        }
        var i = 0
        while (i < n) {
          createId()
          i++
        }
        return arr
      },
      getStatusTxt(status) {
        return status === '已完成' || status === '已冻结'
        // return status === '已完成' || status === '已冻结' || status === '已归档'
      },
      toThousands(num) {
        var result = '',
          counter = 0,
          pon = ''
        num = (num || 0).toString()
        pon = num.slice(num.indexOf('.'))
        num = num.slice(0, num.indexOf('.'))
        for (var i = num.length - 1; i >= 0; i--) {
          counter++
          result = num.charAt(i) + result
          if (!(counter % 3) && i != 0) {
            result = ',' + result
          }
        }
        return result + pon
      },
      getZeroNum(number, count) {
        if (!number || number == 0 || count === 0) {
          return number
        }
        let data = number.toString()
        let num = count
        let idx = data.indexOf('.')
        let zeroP = (num) => {
          let str = ''
          for (let i = 0; i < num; i++) {
            str += '0'
          }
          return str
        }
        if (idx > -1 && num > 0) {
          let n = data.slice(idx + 1, idx + num + 1)
          let count = data.slice(0, idx)
          return count + '.' + n + zeroP(num - n.length)
        } else if (num > 0) {
          return data + '.' + zeroP(num)
        }
      },
      getTaskModel: getTaskModel,
      keyIcon: keyIcon,
      debounceTimer: false
    }
  },
  filters: {
    formatTime(ns) {
      ns = ns * 1000
      return dayjs(ns).format('YYYY/MM/DD HH:mm:ss')
    },
    formatOnlyTime(ns) {
      return dayjs(ns).format('HH:mm')
    },
    formatDate(ns) {
      ns = ns * 1000
      return dayjs(ns).format('YYYY/MM/DD')
    },
    formatDateYMD(ns) {
      ns = ns * 1000
      return dayjs(ns).format('YYYY/M/D')
    },
    formatDateYMD_Slash(ns) {
      ns = ns * 1000
      return dayjs(ns).format('YYYY/MM/DD')
    },
    taskStatusText(val) {
      return taskStatusKeyValue[val] || ''
    },
    taskLevelText(val) {
      return taskLevelKeyValue[val] || ''
    },
    taskLevelOtherName(val) {
      return taskLevelKeyOtherValue[val] || ''
    },
    messageLogActionText(val) {
      return messageLogActoinMap[val] || ''
    },
    formatCommentTime(yymmdd) {
      let time = new Date(yymmdd).getTime()
      return dayjs(time).format('YYYY/MM/DD HH:mm')
    },
    subString(val, len) {
      if (!val) {
        return ''
      }
      if (val.length < len) {
        return val
      } else {
        return val.substring(0, len) + '...'
      }
    }
  },
  beforeRouteLeave: function (to, from, next) {
    if (from && from.meta.rank && (from.meta.rank > to.meta.rank || !to.meta.rank)) {
      //此处判断是如果返回上一层，你可以根据自己的业务更改此处的判断逻辑，酌情决定是否摧毁本层缓存。
      if (this.$vnode && this.$vnode.data.keepAlive) {
        console.log('页面已销毁', from.path, '-', from.meta.rank, '......', to.path, '-', to.meta.rank)
        if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
          if (this.$vnode.componentOptions) {
            var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key
            var cache = this.$vnode.parent.componentInstance.cache
            var keys = this.$vnode.parent.componentInstance.keys
            if (cache[key]) {
              if (keys.length) {
                var index = keys.indexOf(key)
                if (index > -1) {
                  keys.splice(index, 1)
                }
              }
              delete cache[key]
            }
          }
        }
        this.$destroy(true)
      }
    }
    next()
  },
  methods: {
    ...mapMutations('task/task', ['CHANGE_TASK']),
    ...mapMutations('cross/cross', ['SET_ACTIVE']),
    debounceMixin(fn, wait) {
      if (this.debounceTimer !== null) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(fn, wait)
    },
    messageHasClick(e, data, fl) {
      // console.log('------asd-------')
      if (!e.target.classList.contains('clickItem') && fl) return
      console.log(data, e.target.classList.contains('message-click-cross'), data.cross_projects)
      if (e.target.classList.contains('message-click-task') && data.task && data?.raw_data?.action !== 'delete_task') {
        this.openMessageTask(data)
      } else if (e.target.classList.contains('message-click-project') && data.project) {
        this.openMessageTaskProject(data)
      } else if (e.target.classList.contains('message-click-cross-not-pass') && data.cross_projects) {
        this.openMessageCrossLinkNotPass()
      } else if (e.target.classList.contains('message-click-cross') && data.cross_projects) {
        this.openMessageCrossProject(data)
      } else if (e.target.classList.contains('message-click-milestone') && data.cross_projects_milestone) {
        this.openMessageCrossProject(data)
      } else {
        this.openMessageTypeLink(data)
      }
    },
    // 打开任务
    openMessageTask(data) {
      if (data?.raw_data?.action === 'delete_task') return
      this.CHANGE_TASK({
        task_id: data.task_id,
        task_list_id: data.task_list_id,
        project_id: data.project_id,
        visible: true
      })
    },
    // 进入项目
    openMessageTaskProject(data) {
      this.$router.push('/task?isTabShow=true&projectId=' + data.project_id)
    },
    // 工作台我的任务-未通过
    openMessageCrossLinkNotPass() {
      this.SET_ACTIVE('3')
      this.$router.push(`/main/myProject/crossProject`)
    },
    // 打开跨团队项目
    openMessageCrossProject(data) {
      if (data.action === 'cross_project_approval_status_failed') {
        this.openMessageCrossLinkNotPass()
      } else {
        this.$router.push(`/main/myProject/crossProjectDetail?id=${data.cross_projects.id}`)
      }
    },
    openMessageTypeLink(data) {
      if (data.cross_projects && data.action === 'cross_project_approval_status_failed') {
        this.openMessageCrossLinkNotPass()
      } else if (data.cross_projects_milestone) {
        this.$router.push(`/main/myProject/crossProjectDetail?id=${data.cross_projects.id}`)
      } else if (data.task) {
        this.openMessageTask(data)
      } else if (data.project) {
        this.openMessageTaskProject(data)
      } else if (data.cross_projects) {
        this.$router.push(`/main/myProject/crossProjectDetail?id=${data.cross_projects.id}`)
      }
      // switch (data.message_type) {
      //   case '任务':
      //     this.openMessageTask(data)
      //     break
      //   case '项目':
      //     this.openMessageTaskProject(data)
      //     break
      //   case '里程碑':
      //     this.$router.push(`/main/myProject/crossProjectDetail?id=${data.cross_projects.id}`)
      //     break
      // }
    },
  },
  computed: {
    ...mapGetters('layout/layout', ['isBoss']),
    ...mapState('project/project', ['isAdmin'])
  },
  directives: {
    tooltipHide: {
      inserted: function (el) {
        const tooltipId = el.attributes['aria-describedby'].nodeValue
        el.immediateHide = () => {
          const tooltipEl = document.getElementById(tooltipId)
          tooltipEl.style.display = 'none'
        }
        el.addEventListener('mouseleave', el.immediateHide)
      }
    }
  }
}
export default mixin
